import { createContext, useEffect, useState } from 'react';
import { authApi } from '../api/authApi';

export const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const token = localStorage.getItem('access_token');

    if (!token) {
      setLoading(false);
      return;
    }

    authApi
      .me()
      .then((data) => setUser(data.user))
      .catch((err) => {
        // Ne déconnecte que sur un rejet d'authentification confirmé par le serveur (401).
        // Une erreur réseau/requête abandonnée (ex. rechargement de page) ne doit pas
        // effacer une session valide.
        if (err?.status === 401) {
          localStorage.removeItem('access_token');
          localStorage.removeItem('refresh_token');
        }
      })
      .finally(() => setLoading(false));
  }, []);

  async function login(email, password) {
    const data = await authApi.login(email, password);
    localStorage.setItem('access_token', data.access_token);
    localStorage.setItem('refresh_token', data.refresh_token);

    // /auth/login ne renvoie pas les permissions détaillées : on récupère le profil complet
    const { user: fullUser } = await authApi.me();
    setUser(fullUser);
    return fullUser;
  }

  function logout() {
    localStorage.removeItem('access_token');
    localStorage.removeItem('refresh_token');
    setUser(null);
  }

  /** L'utilisateur possède-t-il la permission demandée ? (ex: "pages.manage") */
  function can(permission) {
    return Boolean(user?.permissions?.includes(permission));
  }

  return (
    <AuthContext.Provider value={{ user, loading, login, logout, can }}>
      {children}
    </AuthContext.Provider>
  );
}
